import { useMutation, useQueryClient } from "@tanstack/react-query";

import axios from "../../../../api/axios";

interface PostReportRequest {
  postId: number;
  reasonId: number;
  description?: string;
}

const reportPost = async (data: PostReportRequest) => {
  const response = await axios.post("/reports/posts", data);
  return response.data;
};

export const usePostReportMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reportPost,
    onSuccess: () => {
      // Optionally invalidate queries if needed
      // queryClient.invalidateQueries({ queryKey: ["posts"] });
    },
  });
};
